import React, { useEffect, useState } from 'react';
import { api, fmtDay, AUDIENCE_WORDS, PATH_WORDS, ROLE_WORDS } from './api.js';
import { Card, StatusPill, Pill } from './ui.jsx';
import { inSentence } from './NextSteps.jsx';

export default function MaterialsTab({ boot, mode, onOpen, refreshKey }) {
  const [rows, setRows] = useState(null);
  const [q, setQ] = useState('');
  useEffect(() => {
    let dead = false;
    (async () => {
      const d = mode === 'queue' ? await api('/review-queue') : await api(`/materials?practice=0${q ? `&q=${encodeURIComponent(q)}` : ''}`);
      if (dead) return;
      setRows(d?.success ? (mode === 'queue' ? d.queue : d.materials) : []);
    })();
    return () => { dead = true; };
  }, [mode, q, refreshKey]);

  return (
    <Card title={mode === 'queue' ? 'Waiting for a signature' : 'Materials'}
      right={mode !== 'queue' && <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search title or ID" className="rounded-xl border border-slate-200 px-3 py-1.5 text-xs" />}>
      {!rows ? <p className="text-sm text-slate-400">Loading…</p> : !rows.length ? (
        <p className="text-sm text-slate-500">{mode === 'queue' ? 'Nothing is waiting for a signature.' : 'No materials yet. Start on the Submit tab.'}</p>
      ) : (
        <div className="divide-y divide-slate-100 -mx-5">
          {rows.map((m) => (
            <button key={m.review_id || m.id} type="button" onClick={() => onOpen(m.id)} className="w-full text-left px-5 py-3 hover:bg-slate-50 flex items-start gap-4">
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="text-sm font-semibold text-slate-900 truncate">{m.title}</span>
                  <StatusPill status={m.status} />
                  {mode === 'queue' && <Pill tone="bg-orange-50 text-orange-800 ring-orange-200">{ROLE_WORDS[m.role] || m.role} to sign</Pill>}
                  {m.read_state === 'reading' && <Pill tone="bg-orange-50 text-orange-800 ring-orange-200">Reading</Pill>}
                  {Number(m.open_findings) > 0 && <Pill tone="bg-amber-50 text-amber-800 ring-amber-200">{m.open_findings} open finding{Number(m.open_findings) > 1 ? 's' : ''}</Pill>}
                </div>
                {m.next_step && (
                  <div className="text-xs mt-1 flex items-center gap-1.5">
                    <span className={`inline-block w-1.5 h-1.5 rounded-full ${m.next_step.state === 'now' ? 'bg-orange-500' : 'bg-amber-400'}`} />
                    <span className={m.next_step.state === 'now' ? 'text-orange-800 font-semibold' : 'text-amber-800'}>{m.next_step.state === 'now' ? 'Next, yours' : `Waiting on ${m.next_step.owner}`}: {inSentence(m.next_step.label)}</span>
                    <span className="text-slate-500 truncate">· {m.next_step.detail}</span>
                    {typeof m.steps_done === 'number' && <span className="text-slate-400 shrink-0">· {m.steps_done} of {m.steps_total} done</span>}
                  </div>
                )}
                <div className="text-xs text-slate-500 mt-1">
                  {m.material_id ? <span className="font-mono">{m.material_id}</span> : <span>No ID yet</span>}
                  {' · '}{(m.audience || []).map((a) => AUDIENCE_WORDS[a] || a).join(', ') || 'audience not set'}
                  {' · '}{PATH_WORDS[m.hpms_path] || m.hpms_path}{m.ahca_required ? ' · Agency approval' : ''}
                  {m.desired_use_date ? ` · use ${fmtDay(m.desired_use_date)}` : ''}
                </div>
              </div>
              <span className="text-slate-300">›</span>
            </button>
          ))}
        </div>
      )}
    </Card>
  );
}
